
/* User defined models */
export class Payment {
  id?: string;
  accountNumber?: string;
  amount?: number;
  confirmationNumber?: string;
  currency?: string;
  description?: string;
  examName?: string;
  masterAppointmentId?: string;
  masterPaymentId?: string;
  transactionId?: string;
  paymentStatus?: string;
  paymentType?: string;
  sequenceNumber?: number;
  transactionDate?: any;
  transactionType?: string;
  tax?: number;
  totalCost?: number = 0.00;
  refund?: number = 0.00;
  settlementAmount: number;
  settlementCurrency: string;

  constructor(
    amount?: number,
    currency?: string,
    transactionType?: string,
    accountNumber?: string,
    confirmationNumber?: string,
    description?: string,
    examName?: string,
    id?: string,
    masterAppointmentId?: string,
    masterPaymentId?: string,
    paymentStatus?: string,
    paymentType?: string,
    refund?: number,
    sequenceNumber?: number,
    tax?: number,
    totalCost?: number,
    transactionDate?: any,
    transactionId?: string,
    settlementAmount?: number,
    settlementCurrency?: string
  ) {
    this.amount = amount;
    this.currency = currency;
    this.transactionType = transactionType;
    this.accountNumber = accountNumber;
    this.confirmationNumber = confirmationNumber;
    this.description = description;
    this.examName = examName;
    this.id = id;
    this.masterAppointmentId = masterAppointmentId;
    this.masterPaymentId = masterPaymentId;
    this.paymentStatus = paymentStatus;
    this.paymentType = paymentType;
    this.refund = refund;
    this.sequenceNumber = sequenceNumber;
    this.tax = tax;
    this.totalCost = totalCost;
    this.transactionDate = transactionDate;
    this.transactionId = transactionId;
    this.settlementAmount = settlementAmount;
    this.settlementCurrency = settlementCurrency;
  }
}
